<template>
    <li>   
        <span :class="'no'+1">
            <!-- {{hasChild}} -->
            <span v-if="hasChild" @click="toggle" class="sj-view-jt"> 
                <i class="el-icon-caret-right" v-if="!isOpen"></i>
                <i class="el-icon-caret-bottom" v-else></i>
            </span>
            <!-- 末节点 --> 

            <span @click="activeItem(data)" class="no-item">{{ data[treeProps.label] }} </span>
        </span>
        <el-collapse-transition>
            <ul v-show="isOpen" v-if="hasChild" class="no9">
                <tree-item v-for="(item, index) in data[treeProps.children]" :data="item" :key="index" :treeProps="treeProps" @active="activeTreeItem" :level="5"></tree-item>
            </ul>
        </el-collapse-transition>
    </li>
</template>

<script>
export default {
    name: 'TreeItem', //递归组件必须有name
    props: {
        data: {
            type: [Object, Array], //多个可能的类型
            required: true
        },
        level:{
            type:Number,
            default:1
        },
        // label、children 默认值
      treeProps:{
          type:Object,
          default:()=>({
            children:'children',
            label:'label'
          })
        }
    },
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
      // 判断当前级别是否还有children
        hasChild() {
            return this.data[this.treeProps.children] && this.data[this.treeProps.children].length
        }
    },
    methods: {
        activeTreeItem(item){
            this.$emit("active",item)
        },
        activeItem(item){  
            this.$emit("active",item)
        },
      // 点击子菜单也要判断是否有children，有就展开
        toggle() {
            if(this.hasChild) {
                this.isOpen = !this.isOpen
            }
        }
    }
}
</script>

<style scoped> 
ul {
    list-style: none; 
    padding-left: 20px;
}
li {
      color: #000;
}
li > span {
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    display: block;
}
i{
    color: #ede9e2!important;
}
.sj-view-jt{
    border-radius: 4px;
    padding: 0 4px;
    /* margin: 0 2px 0 0 ; */
}
.sj-view-jt:hover{
    background: #ede9e2;
    color: #6a6058!important;
}
.sj-view-jt:hover i{ 
    color: #6a6058!important;
}

.no1{
    background: #6a6058;
    color: #ede9e2;
    font-size: 14px;
    padding: 5px 0;
    margin: 0 0 4px 0; 
    display: flex;
} 

.no-item{
    padding:0 0 0 4px;
    display: block;
    width: 100%;
    transition: .2s;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px; 
}
.no-item:hover{
    background: #ede9e2;
    color: #6a6058;
}
.no2{
    background:#cbc3b7;
    color: #4d443b;
    font-size: 14px;
    padding: 5px 0;
    margin: 4px 0 4px 0;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px; 
    /* border-radius: 5px; */
}
.no3{
    /* background: goldenrod; */
    font-size: 14px;
    padding: 5px 0 5px 5px;
    margin: 4px 0;
    /* border-radius: 5px; */
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    
} 
.no1,.no2,.no3{
    transition: .2s;
    overflow: hidden;
}
.no1:hover{
    background: rgba(0,0,0,0.4);
    padding-left: 8px;
}
.no2:hover{
    background: rgba(0,0,0,0.4);
    padding-left: 8px;
}
.no3:hover{
    background: rgba(0,0,0,0.2);
    padding-left: 8px;
}

</style>